package com.partejar.app.feature.relacionamentos.data
import com.partejar.app.feature.gestantes.data.GestanteAddress

enum class RelacionamentoFilter(val apiValue: String) { ALL("TODOS"), MEETING("REUNIAO"), FOLLOW_UP("FOLLOW_UP"), LOST("PERDIDOS") }
enum class RelacionamentoStage(val apiValue: String) { CAPTURE("CAPTACAO"), MEETING("REUNIAO_APRESENTACAO"), WAITING("AGUARDANDO_FECHAMENTO"), CONTRACT("CONTRATO"), LOST("ARQUIVADA_PERDIDA") }
enum class InteractionKind(val apiValue: String) { CONTACT("PRIMEIRO_CONTATO"), MEETING("REUNIAO"), FOLLOW_UP("FOLLOW_UP"), WHATSAPP("WHATSAPP"), INSTAGRAM("INSTAGRAM"), OTHER("OUTRO") }
enum class RelationshipOrigin(val apiValue: String) { WHATSAPP("WHATSAPP"), INSTAGRAM("INSTAGRAM"), REFERRAL("INDICACAO"), OTHER("OUTRO") }

data class RelationshipItem(val id: Long, val name: String, val babyName: String?, val summary: String?, val maternity: String?, val stage: RelacionamentoStage, val needsAttention: Boolean, val nextFollowUp: String?, val nextMeeting: String?)
data class RelationshipPage(val items: List<RelationshipItem>, val last: Boolean)
data class RelationshipDetail(
    val id: Long,
    val name: String,
    val babyName: String?,
    val maternity: String?,
    val stage: RelacionamentoStage,
    val needsAttention: Boolean,
    val nextMeeting: String?,
    val interactions: List<Interaction>,
    val stageHistory: List<StageHistory> = emptyList(),
    val dueDate: String? = null,
    val prenatalType: String? = null,
    val livesInBh: Boolean = true,
    val gestationalWeeks: Int? = null,
    val gestationalDays: Int? = null,
    val gestationalReportedAt: String? = null,
    val origin: String? = null,
    val address: GestanteAddress = GestanteAddress()
)
data class Interaction(val type: InteractionKind, val occurredAt: String, val note: String?, val nextFollowUp: String?)
data class StageHistory(val stage: RelacionamentoStage, val startedAt: String, val endedAt: String?, val reason: String?, val changedBy: String?)
sealed interface RelationshipOriginEdit {
    data object Unchanged : RelationshipOriginEdit
    data class Set(val value: String?) : RelationshipOriginEdit
}
data class RelationshipEdit(
    val name: String,
    val babyName: String?,
    val maternity: String?,
    val dueDate: String?,
    val livesInBh: Boolean? = null,
    val address: GestanteAddress? = null,
    val origin: RelationshipOriginEdit = RelationshipOriginEdit.Unchanged
)
data class NewRelationship(val name: String, val babyName: String?, val maternity: String?, val prenatalType: String? = null, val origin: String? = null, val address: GestanteAddress = GestanteAddress(), val dueDate: String? = null)

interface RelacionamentosDataSource {
    suspend fun list(filter: RelacionamentoFilter, page: Int = 0): RelationshipPage
    suspend fun detail(id: Long): RelationshipDetail
    suspend fun create(input: NewRelationship): RelationshipDetail
    suspend fun interact(id: Long, kind: InteractionKind, note: String?, nextFollowUp: String?): RelationshipDetail
    suspend fun scheduleMeeting(id: Long, startsAt: String, endsAt: String, note: String?): RelationshipDetail
    suspend fun move(id: Long, stage: RelacionamentoStage, reason: String? = null): RelationshipDetail
    suspend fun update(id: Long, current: RelationshipDetail, edit: RelationshipEdit): RelationshipDetail
    suspend fun updateDueDate(id: Long, current: RelationshipDetail, dueDate: String): RelationshipDetail
}
